import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpService } from '../helper/httpService';
import { Constants } from '../helper/constants';

export interface UserSettingsResponse {
  profile: {
    avatarId: string;
  };
  settings: {
    autoPinPcnBlock: boolean;
    defaultStages: {
      progressionPathA?: number;
      progressionPathB?: number;
      progressionPathC?: number;
      progressionPathD?: number;
      progressionPathE?: number;
      progressionPathF?: number;
      progressionPathG?: number;
    };
  };
}

export interface UpdateUserSettingsRequest {
  profile?: {
    avatarId?: string;
  };
  settings?: {
    autoPinPcnBlock?: boolean;
    defaultStages?: {
      progressionPathA?: number;
      progressionPathB?: number;
      progressionPathC?: number;
      progressionPathD?: number;
      progressionPathE?: number;
      progressionPathF?: number;
      progressionPathG?: number;
    };
  };
}

@Injectable({ providedIn: 'root' })
export class UserSettingsService {
  private readonly userSettingsUrl = Constants.serverUrl + 'api/account/userSettings';

  constructor(public http: HttpService) {}

  getUserSettings(): Observable<UserSettingsResponse | null> {
    return this.http.Get(this.userSettingsUrl) as Observable<UserSettingsResponse | null>;
  }

  getUserSetting(settingKey: string): Observable<any> {
    return this.http.Get(this.userSettingsUrl + '/' + settingKey);
  }

  updateUserSettings(request: UpdateUserSettingsRequest): Observable<any> {
    const data = JSON.stringify(request);
    return this.http.Post(this.userSettingsUrl, data);
  }

  isPcnPanelLocked(): Observable<boolean> {
    return this.getUserSetting('autoPinPcnBlock').pipe(map((value: any) => value === true));
  }

  setPcnPanelLocked(lock: boolean): Observable<any> {
    const req: UpdateUserSettingsRequest = {
      settings: {
        autoPinPcnBlock: lock,
      },
    };
    return this.updateUserSettings(req);
  }
}
